import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { FormRenderer as BasicHealthFormRenderer } from "src/modules/basic-health";
import { FormRenderer as HtxFormRenderer } from "src/modules/htx";
import { FormRenderer as KdFormRenderer } from "src/modules/kd";
import { FormRenderer as KtxFormRenderer } from "src/modules/ktx";
import { FormRenderer as LtxFormRenderer } from "src/modules/ltx";

export const FormRenderer: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxFormRenderer />;
	}
	if (mod === "ktx") {
		return <KtxFormRenderer />;
	}
	if (mod === "kd") {
		return <KdFormRenderer />;
	}
	if (mod === "basic_health") {
		return <BasicHealthFormRenderer />;
	}
	if (mod === "ltx") {
		return <LtxFormRenderer />;
	}
	return null;
};
